import { api } from "@/lib/api";
import { Hotel, HotelDtoSchema, hotelFromDto, hotelToDto } from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getHotelQueryOptions, getHotelsQueryOptions } from "./get.hooks";

export function useUpdateHotel(opts?: {
  onSuccess?: (hotel: Hotel) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (hotel: Hotel) => {
      const dto = hotelToDto(hotel);
      const result = await api.put("/api/hotels", dto, HotelDtoSchema);
      return hotelFromDto(result);
    },
    onSuccess: (hotel) => {
      queryClient.setQueryData(getHotelsQueryOptions.queryKey, (old) =>
        old?.map((h) => (h.id !== hotel.id ? h : hotel)),
      );
      queryClient.setQueryData(
        getHotelQueryOptions(hotel.id).queryKey,
        () => hotel,
      );
      toast({
        title: "toast.hotelUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(hotel);
    },
    onError: () => {
      toast({
        title: "toast.updateHotelError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
